module.exports = __webpack_public_path__ + "img/delete-icon.d80d69fd.svg";